import $ from 'jquery';
import {is_function, isMSIE} from '../../../Helpers/js/simple.functions';
import LP from '../0-lp';

LP.UI.GoogleCharts = {
    apiSuspend: false,
    apiLoaded: false,
    afterLoadFn: [],

    cache: {},
    cacheLifeTime: 30000,

    defaultWidth: 500,
    dafaultHeight: 500,

    animation: {
        duration: 500,
        easing: 'linear'
    },

    loadAPI: function () {
        if (!LP.UI.GoogleCharts.apiLoaded && !LP.UI.GoogleCharts.apiSuspend) {
            LP.UI.GoogleCharts.apiSuspend = true;
            $.ajaxSetup({cache: true});

            window.google.charts.load('current', {
                'packages': ['corechart', 'table'],
                'callback': function () {
                    LP.UI.GoogleCharts.apiSuspend = false;
                    LP.UI.GoogleCharts.apiLoaded = true;

                    // Call after API Loading
                    for (var n = 0; n < LP.UI.GoogleCharts.afterLoadFn.length; n++) {
                        LP.UI.GoogleCharts.afterLoadFn[n]();
                    }
                    LP.UI.GoogleCharts.afterLoadFn = [];
                }
            });
            $.ajaxSetup({cache: false});
        }
    },

    fetchChart: function (chartDiv, forceCollect, forceRefresh) {
        // Collect fetch requests for multiple charts
        if (chartDiv.length > 1 || forceCollect) {
            var chartRequests = [];
            chartDiv.each(function () {
                var request = LP.UI.GoogleCharts.fetchChart($(this), false, forceRefresh);
                if (request !== null) {
                    chartRequests.push(request);
                }
            });
            return chartRequests;
        }

        var chartType = chartDiv.attr('chart-type');
        var dataRequest = LP.UI.GoogleCharts.getRequestData(chartDiv);

        var dataHash = $.param(dataRequest);
        var now = Date.now();

        // Check if not cached
        if (forceRefresh || !LP.UI.GoogleCharts.cache[dataHash] || (LP.UI.GoogleCharts.cache[dataHash].timestamp + LP.UI.GoogleCharts.cacheLifeTime) < now) {
            return {
                mode: 'query',
                div: chartDiv,
                type: chartType,
                params: dataRequest,
                hash: dataHash
            };
        }
        // If cached, return cached dsd
        else {
            return {
                mode: 'cache',
                div: chartDiv,
                type: chartType,
                data: LP.UI.GoogleCharts.cache[dataHash].data
            };
        }
    },

    renderCharts: function (charts, afterFinish) {
        LP.UI.GoogleCharts.loadAPI();

        var chartsParams = {},
            idx = 0;
        for (var i = 0; i < charts.length; i++) {
            // If not in cache, collect querie data
            if (charts[i].mode == 'query') {
                chartsParams['gc_' + idx] = charts[i].params;
                idx++;
            }
            // If in cache, call draw callback with cached data
            else if (charts[i].mode == 'cache') {
                LP.UI.GoogleCharts.doRenderChart(charts[i].div, charts[i].type, charts[i].data);
            }
        }

        // Query non-chached charts, and render them
        if (!$.isEmptyObject(chartsParams)) {
            chartsParams['num_gc'] = idx;

            const $parent = $(charts[0].div).parent();
            $parent.timedLoader(1);
            window.Browser.send('backend/collectGoogleChartData/', $.param(chartsParams), function (chartsData) {
                idx = 0;

                for (var i = 0; i < charts.length; i++) {
                    $parent.timedLoader(false);
                    if (charts[i].mode == 'query') {
                        var chartData = chartsData[idx];
                        LP.UI.GoogleCharts.cache[charts[i].hash] = {
                            data: chartData,
                            timestamp: Date.now()
                        };
                        LP.UI.GoogleCharts.doRenderChart(charts[i].div, charts[i].type, chartData);
                        idx++;
                    }
                }
                if (is_function(afterFinish)) {
                    afterFinish();
                }
            });
        } else {
            if (is_function(afterFinish)) {
                afterFinish();
            }
        }
    },

    doRenderChart: function (chartDiv, chartType, chartData, afterFinish) {

        var onRenderFunction = function () {
            var drawFunction = LP.UI.GoogleCharts.getDrawFunction(chartType);
            drawFunction(chartDiv, chartData);
            chartDiv.show();
            if (is_function(afterFinish)) {
                afterFinish();
            }
        };

        // containerTimeout till API loaded
        if (!LP.UI.GoogleCharts.apiLoaded && LP.UI.GoogleCharts.apiSuspend) {
            LP.UI.GoogleCharts.afterLoadFn.push(onRenderFunction);
        }
        // execute render calls after loaded
        else if (LP.UI.GoogleCharts.apiLoaded) {
            onRenderFunction();
        }
    },

    getDrawFunction: function (chartType) {
        if (chartType == 'bar' || chartType == 'stacked-bar') {
            return LP.UI.GoogleCharts.drawBarChart;
        } else if (chartType == 'column' || chartType == 'stacked-column') {
            return LP.UI.GoogleCharts.drawColumnChart;
        } else if (chartType == 'pie' || chartType == 'pie3d' || chartType == 'donut') {
            return LP.UI.GoogleCharts.drawPieChart;
        } else if (chartType == 'table') {
            return LP.UI.GoogleCharts.drawTableChart;
        } else if (chartType == 'area') {
            return LP.UI.GoogleCharts.drawAreaChart;
        } else if (chartType == 'line' || chartType == 'stepped-area') {
            return LP.UI.GoogleCharts.drawLineChart;
        } else if (chartType == 'histogram') {
            return LP.UI.GoogleCharts.drawHistogram;
        } else if (chartType == 'candle') {
            return LP.UI.GoogleCharts.drawCandleChart;
        } else if (chartType == 'scatter') {
            return LP.UI.GoogleCharts.drawScatterChart;
        } else if (chartType == 'calendar') {
            return LP.UI.GoogleCharts.drawCalendarChart;
        }

        return function () {
        };
    },

    getRequestData: function (chartDiv) {
        var options = {};
        if (chartDiv.attr('chart-type')) {
            options.chartType = chartDiv.attr('chart-type');
        }
        if (chartDiv.attr('chart-style')) {
            options.chartStyle = chartDiv.attr('chart-style');
        }
        if (chartDiv.attr('question-group')) {
            options.groupId = chartDiv.attr('question-group');
        }
        if (chartDiv.attr('option-id')) {
            options.optionId = chartDiv.attr('option-id');
        }
        if (chartDiv.attr('input-id')) {
            options.inputId = chartDiv.attr('input-id');
        }
        if (chartDiv.attr('scale-id')) {
            options.scaleId = chartDiv.attr('scale-id');
        }
        if (chartDiv.attr('column-id')) {
            options.columnId = chartDiv.attr('column-id');
        }
        if (chartDiv.attr('row-id')) {
            options.rowId = chartDiv.attr('row-id');
        }
        if (chartDiv.attr('data')) {
            options.data = chartDiv.attr('data');
        }
        if (chartDiv.attr('value-format')) {
            options.valueFormat = chartDiv.attr('value-format');
        }
        return {
            questionId: chartDiv.attr('question-id'),
            options: options
        };
    },

    drawGoogleChart: function (chartDiv, chartType, chartData, chartWidth, chartHeight) {
        var dataTable = new window.google.visualization.DataTable();

        LP.UI.GoogleCharts.setColumns(dataTable, chartData.cols);
        LP.UI.GoogleCharts.setRows(dataTable, chartData.rows, chartData.cols);
        // Create & draw chart
        var googleChart = 0;
        if (chartType == 'bar' || chartType == 'stacked-bar') {
            googleChart = new window.google.visualization.BarChart(chartDiv.get(0));
        } else if (chartType == 'column' || chartType == 'stacked-column') {
            googleChart = new window.google.visualization.ColumnChart(chartDiv.get(0));
        } else if (chartType == 'line') {
            googleChart = new window.google.visualization.LineChart(chartDiv.get(0));
        } else if (chartType == 'scatter') {
            googleChart = new window.google.visualization.ScatterChart(chartDiv.get(0));
        } else if (chartType == 'pie' || chartType == 'pie3d' || chartType == 'donut') {
            googleChart = new window.google.visualization.PieChart(chartDiv.get(0));
        } else if (chartType == 'table') {
            googleChart = new window.google.visualization.Table(chartDiv.get(0));
        }
        // Setup chart options & specificas
        var chartOptions = LP.UI.GoogleCharts.getChartOptions(chartDiv, chartType, chartData, chartWidth, chartHeight);

        // Draw chart
        googleChart.draw(dataTable, chartOptions);
        // Add download button

        LP.UI.GoogleCharts.createDownloadButton(chartDiv, googleChart, chartOptions);
        return;
    },

    drawBarChart: function (chartDiv, chartData) {
        var chartType = chartDiv.attr('chart-type');
        var chartHeight;

        var factor = chartType == 'stacked-bar' ? 50 : 25;
        chartHeight = 300 + chartData.numRows * factor;
        if (chartHeight < LP.UI.GoogleCharts.dafaultHeight) {
            chartHeight = LP.UI.GoogleCharts.dafaultHeight;
        }

        return LP.UI.GoogleCharts.drawGoogleChart(chartDiv, chartType, chartData, 0, chartHeight);
    },

    drawColumnChart: function (chartDiv, chartData) {
        var chartType = chartDiv.attr('chart-type');
        var chartWidth = 0;
        var chartHeight = 0;

        //chartWidth = 300+chartData.numRows*80;
        //if( chartWidth < LP.UI.GoogleCharts.defaultWidth ) chartWidth = LP.UI.GoogleCharts.defaultWidth;

        return LP.UI.GoogleCharts.drawGoogleChart(chartDiv, chartType, chartData, chartWidth, chartHeight);
    },

    drawPieChart: function (chartDiv, chartData) {
        var chartType = chartDiv.attr('chart-type');
        return LP.UI.GoogleCharts.drawGoogleChart(chartDiv, chartType, chartData, 0, 0);
    },

    drawLineChart: function (chartDiv, chartData) {
        return LP.UI.GoogleCharts.drawGoogleChart(chartDiv, 'line', chartData, 0, 0);
    },

    drawScatterChart: function (chartDiv, chartData) {
        return LP.UI.GoogleCharts.drawGoogleChart(chartDiv, 'scatter', chartData, 0, 0);
    },

    drawTableChart: function (chartDiv, chartData) {
        return LP.UI.GoogleCharts.drawGoogleChart(chartDiv, 'table', chartData, 0, 0);
    },

    drawHistogram: function (chartDiv, chartData) {
        var chartArray = window.google.visualization.arrayToDataTable(chartData.table);
        var chartOptions = LP.UI.GoogleCharts.getChartOptions(chartDiv, 'histogram', chartData);
        chartOptions.interpolateNulls = false;

        var googleChart = new window.google.visualization.Histogram(chartDiv.get(0));
        googleChart.draw(chartArray, chartOptions);

        LP.UI.GoogleCharts.createDownloadButton(chartDiv, googleChart, chartOptions);
    },

    drawAreaChart: function (chartDiv, data) {
        var gdata = window.google.visualization.arrayToDataTable(data.answers);
        var options = LP.UI.GoogleCharts.getChartOptions(chartDiv, 'area', data);

        var chart = new window.google.visualization.AreaChart(chartDiv.get(0));
        chart.draw(gdata, options);

        LP.UI.GoogleCharts.createDownloadButton(chartDiv, chart, options);
    },

    drawCandleChart: function (chartDiv, data) {
        var gdata = window.google.visualization.arrayToDataTable(data.answers, true);

        var options = LP.UI.GoogleCharts.getChartOptions(chartDiv, 'candle', data);
        options.vAxis.minValue = data.min;
        options.vAxis.maxValue = data.max;

        var chart = new window.google.visualization.CandlestickChart(chartDiv.get(0));
        chart.draw(gdata, options);

        LP.UI.GoogleCharts.createDownloadButton(chartDiv, chart, options);
    },

    createDownloadButton: function (chartDiv, chart) {
        if (typeof (chart.getImageURI) != 'function') return;
        var downloadLink = $('<a download="" href="#"> ' + $('#downloadChartText').html() + ' </a>');
        downloadLink.addClass('icon-picture grey-btn download-chart');
        // downloadLink.attr('href', chart.getImageURI());
        downloadLink.attr('download', chartDiv.attr('chart-title') + '.png');
        downloadLink.attr('title', $('#downloadChartHint').html());

        var clickfunc = function () {
            downloadLink.attr('href', chart.getImageURI());
            var image;
            if (isMSIE() && typeof window.navigator.msSaveBlob === 'undefined') { // special case for IE 9
                image = document.createElement('img');
                // eslint-disable-next-line no-undef
                $(img).on('load', function () {
                    // eslint-disable-next-line no-undef
                    LP.dlgSaveImage.open(downloadLink.text(), $(img), img.width, img.height);
                });
                // eslint-disable-next-line no-undef
                img.src = downloadLink.attr('href');
                return false;
            } else if (typeof window.navigator.msSaveBlob !== 'undefined') { // IE 10 and above + Edge
                image = document.createElement('img');
                $(image).on('load', function () {
                    var canvas = document.createElement('canvas');
                    canvas.width = image.width;
                    canvas.height = image.height;
                    var ctx = canvas.getContext('2d');
                    ctx.drawImage(image, 0, 0, image.width, image.height);
                    window.navigator.msSaveBlob(canvas.msToBlob(), downloadLink.attr('download'));
                });
                image.src = downloadLink.attr('href');
                return false;
            } else {
                return true;
            }

        };
        downloadLink.click(clickfunc);
        downloadLink.appendTo(chartDiv);
    },

    setColumns: function (dataTable, dataColumns) {
        if (!dataTable || !dataColumns) {
            return false;
        }

        for (var col = 0; col < dataColumns.length; col++) {
            var colData = dataColumns[col];
            if (colData.type == 'tooltip') {
                dataTable.addColumn({
                    'type': 'string',
                    'role': 'tooltip',
                    'p': {'html': true}
                });
            } else if (colData.type == 'label') {
                dataTable.addColumn({
                    'type': 'string',
                    'role': 'annotation'
                });
            } else if (colData.type == 'hover') {
                dataTable.addColumn({
                    'type': 'string',
                    'role': 'annotationText'
                });
            }// Hover-Text
            else if (colData.type == 'int') {
                dataTable.addColumn('number', colData.label);
            } else if (colData.type == 'float') {
                dataTable.addColumn('number', colData.label);
            } else {
                dataTable.addColumn(colData.type, colData.label);
            }
        }
        return true;
    },

    setRows: function (dataTable, dataRows, dataColumns) {
        if (dataTable && dataRows) {
            // convert data values to float/int (json_encode may interpret floats into strings)
            for (var col = 0; col < dataColumns.length; col++) {
                var colType = dataColumns[col].type;
                if (colType == 'float' || colType == 'int') {
                    for (var row = 0; row < dataRows.length; row++) {
                        if (typeof dataRows[row][col] == 'string') {
                            dataRows[row][col] = colType == 'float' ? parseFloat(dataRows[row][col]) : parseInt(dataRows[row][col]);
                        }
                    }
                }
            }
            dataTable.addRows(dataRows);
        }
    },

    getChartOptions: function (chartDiv, chartType, chartData, chartWidth, chartHeight) {
        var chartOptions;

        if (chartType == 'table') {
            chartOptions = LP.UI.GoogleCharts.getTableOptions(chartDiv, chartData);
        } else {
            chartOptions = LP.UI.GoogleCharts.getDefaultOptions(chartDiv, chartData);
        }

        chartOptions.tooltip = {isHtml: true};

        if (chartType == 'stacked-bar' || chartType == 'stacked-column') {
            chartOptions.isStacked = true;
        }

        if (chartType == 'pie3d') {
            chartOptions.is3D = true;
        }
        if (chartType == 'donut') {
            chartOptions.pieHole = 0.4;
        }

        if (chartType == 'bar' || chartType == 'column' || chartType == 'stacked-bar' || chartType == 'stacked-column') {
            chartOptions.bar = {groupWidth: '90%'};
        }

        if (chartType == 'pie' || chartType == 'pie3d' || chartType == 'donut') {
            chartOptions.pieSliceText = chartDiv.attr('value-format') == 'abs' ? 'value' : 'percentage';
        }

        if (chartData.hAxis) {
            if (chartData.hAxis.minValue) {
                chartOptions.hAxis.minValue = chartData.hAxis.minValue;
            }
            if (chartData.hAxis.maxValue) {
                chartOptions.hAxis.maxValue = chartData.hAxis.maxValue;
            }
            if (chartData.hAxis.gridlines) {
                chartOptions.hAxis.gridlines = {
                    color: '#AAAAAA',
                    count: chartData.hAxis.gridlines
                };
            }
        }

        if (chartType == 'histogram') {
            chartOptions.bar = {groupWidth: '90%'};
            chartOptions.histogram = {hideBucketItems: true};
            chartOptions.hAxis.textPosition = 'out';
        }

        //chartOptions.hAxis.direction = -1;
        //chartOptions.hAxis.slantedText = true;
        //chartOptions.hAxis.slantedTextAngle = 45;

        if (chartData.vAxis) {
            if (chartData.vAxis.minValue) {
                chartOptions.vAxis.minValue = chartData.vAxis.minValue;
            }
            if (chartData.vAxis.maxValue) {
                chartOptions.vAxis.maxValue = chartData.vAxis.maxValue;
            }
        }

        if (!chartWidth) {
            var parent = chartDiv.parent();
            var parentWidth = parent.width();
            var factor = 0.8;
            if (chartType == 'pie' || chartType == 'pie3d' || chartType == 'donut') {
                factor = 0.5;
            }
            chartWidth = parentWidth * factor;
        }
        if (chartWidth) {
            chartOptions.width = chartWidth;
        }
        if (chartHeight) {
            chartOptions.height = chartHeight;
        }

        return chartOptions;
    },

    getDefaultOptions: function (chartDiv, data) {
        if (data.branding == null) {
            data.branding = '';
        }
        var hAxis = {
            title: data.hAxis && data.hAxis.title ? (data.hAxis.title + '\n' + data.branding) : data.branding
        };
        if (chartDiv.attr('hmin')) {
            hAxis.minValue = chartDiv.attr('hmin');
        }
        if (chartDiv.attr('hmax')) {
            hAxis.maxValue = chartDiv.attr('hmax');
        }
        if (chartDiv.attr('hformat')) {
            hAxis.format = chartDiv.attr('hformat');
        }
        var vAxis = {
            title: data.vAxis && data.vAxis.title ? data.vAxis.title : null,
            format: '#',
            minValue: 0
        };
        if (chartDiv.attr('vmin')) {
            vAxis.minValue = chartDiv.attr('vmin');
        }
        if (chartDiv.attr('vmax')) {
            vAxis.maxValue = chartDiv.attr('vmax');
        }

        var chartLegend = {position: 'right'};
        if (chartDiv.attr('legend')) {
            chartLegend.position = chartDiv.attr('legend');
        }

        let chartArea;
        if (chartLegend.position == 'top' || chartLegend.position == 'bottom') {
            chartLegend.maxLines = 3;
            chartArea = {
                width: '80%',
                height: '70%'
            };
        } else if (chartLegend.position == 'left' || chartLegend.position == 'right' || chartLegend.position == 'labeled') {
            chartArea = {width: '60%', height: '70%'};
        } else if (chartLegend.position == 'none') {
            chartArea = {
                width: '75%',
                height: '75%'
            };
        }

        var chartTitle = chartDiv.attr('chart-title');
        var chartOptions = {
            title: chartTitle,
            legend: chartLegend,
            chartArea: chartArea,
            vAxis: vAxis,
            hAxis: hAxis,
            height: LP.UI.GoogleCharts.dafaultHeight,
            width: LP.UI.GoogleCharts.defaultWidth,
            animation: LP.UI.GoogleCharts.animation
        };

        return chartOptions;
    },

    getTableOptions: function (chartDiv) {
        var chartOptions = {
            allowHtml: true,
            showRowNumber: false,
            cssClassNames: {
                headerRow: 'google-table-head-row',
                tableRow: 'google-table-even-row',
                oddTableRow: 'google-table-odd-row',
                selectedTableRow: 'google-table-sel-row',
                hoverTableRow: 'google-table-hover-row',
                headerCell: 'google-table-th',
                tableCell: 'google-table-td'
            }
        };

        if (chartDiv.attr('sort') != 'off') {
            chartOptions.sortColumn = 1;
            if (chartDiv.attr('sort') != 'asc') {
                chartOptions.sortAscending = false;
            }
        }

        return chartOptions;
    }

};